export default __webpack_public_path__ + "24fd0d939bea21082c044dea4e795c93.svg";